import { render, staticRenderFns } from "./news-details.vue?vue&type=template&id=68039b4e&scoped=true"
import script from "./news-details.vue?vue&type=script&lang=js"
export * from "./news-details.vue?vue&type=script&lang=js"
import style0 from "./news-details.vue?vue&type=style&index=0&id=68039b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68039b4e",
  null
  
)

export default component.exports